export class CertificationSchemeModel {
    public id?: string | null = null;
    public title?: string | null = null;
    public description?: string | null = null;

    constructor(data?: Partial<CertificationSchemeModel>) {
        Object.assign(this, data);
    }
}
